import { ModuleState } from '@gongxigames/framework/slot/fragments/module/ModuleState';
import { LogicEvents } from '@gongxigames/framework/slot/services/logic';
import { ReelsEvents } from '@gongxigames/framework/slot/modules/reels';
import {
    MultiSetsPromotionModule,
    MultiSetsPromotionModuleEvents,
    MultiSetsPromotionStates,
    IPromotionLogic,
} from '@gongxigames/framework/promotions';

export class MultiSetsPromotionInProgressState extends ModuleState<null, MultiSetsPromotionModule, MultiSetsPromotionModuleEvents> {
    private isFinished = false;

    public onEnterState(): void {
        this.isFinished = false;
        this.module.activateCounter();
    }

    public onLeaveState(): void {
        this.emit('Autoplay.FORCE_STOP');
        this.emit('General.Promotion.DeactivateCounter');
    }

    protected setupEvents(): void {
        this.setEventHandler(ReelsEvents.REELS_SPINNING_STARTED, this.onReelsSpinningStarted.bind(this));
        this.setEventHandler(ReelsEvents.ALL_REELS_STOPPED, this.onAllReelsStopped.bind(this));
        this.setEventHandler('General.Flow.PAID_ROUND_ENDED', this.onPaidRoundEnded.bind(this));
        this.setEventHandler(LogicEvents.RESPONSE, this.onResponse.bind(this));
    }

    protected subtractPromotion(): void {
        this.promotion.subtractPromotion();
        this.module.updateCounter();
    }

    private onResponse(): void {
        if (this.promotion.isEndOfPromotion()) {
            this.emit('General.Slot.SPIN.DISABLE', MultiSetsPromotionModule.NAME);
        }
    }

    private onReelsSpinningStarted(): void {
        if (this.promotion.isNextPromotion()) {
            this.subtractPromotion();
        }
    }

    private onAllReelsStopped(): void {
        if (this.promotion.isLastPromotion()) {
            this.emit('Autoplay.FORCE_STOP');
        }
    }

    protected onPaidRoundEnded(): void {
        if (this.promotion.isEndOfPromotion() && !this.isFinished) {
            this.isFinished = true;
            this.module.gotoState(MultiSetsPromotionStates.END);
        }
    }

    private get promotion(): IPromotionLogic {
        return this.module.getPromotion();
    }
}
